<template>
  <div class="admin-dashboard">
    <div class="dashboard-container">
      <div class="dashboard-header">
        <h1 class="dashboard-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8.5 5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293z"/>
            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
          </svg>
          Console du Big Boss
        </h1>
        <p class="dashboard-subtitle">Tableau de bord administrateur pour la gestion système</p>
      </div>

      <div class="dashboard-grid">
        <!-- Admin Tools Card -->
        <div class="dashboard-card admin-tools">
          <div class="card-header">
            <div class="card-icon admin-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"/>
                <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"/>
              </svg>
            </div>
            <div class="card-title-section">
              <h3 class="card-title">Outils d'administration</h3>
              <p class="card-description">Gestion des invitations et des utilisateurs</p>
            </div>
          </div>

          <div class="card-content">
            <router-link
              :to="{ name: 'inviteCreator' }"
              class="action-button primary-button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
              </svg>
              Créer des invitations
            </router-link>
            <router-link
              :to="{ name: 'accessManager' }"
              class="action-button secondary-button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"/>
              </svg>
              Gérer les accès (Workspace, test, abonné)
            </router-link>
            <router-link
              :to="{ name: 'quoteBuilder' }"
              class="action-button secondary-button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm1 3h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1m0 3h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1m0 3h4a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1"/>
              </svg>
              Générer un devis
            </router-link>
            <router-link
              :to="{ name: 'clientCities' }"
              class="action-button secondary-button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
              </svg>
              Clients par ville
            </router-link>
          </div>
        </div>

        <!-- Suivi CSM Card -->
        <div class="dashboard-card csm-tracking">
          <div class="card-header">
            <div class="card-icon csm-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"/>
              </svg>
            </div>
            <div class="card-title-section">
              <h3 class="card-title">Suivi CSM</h3>
              <p class="card-description">Une ligne par utilisateur : accès, modules, usage et santé du compte</p>
            </div>
          </div>
          <div class="card-content">
            <router-link
              :to="{ name: 'csmUsage' }"
              class="action-button secondary-button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm15 2h-4v3h4zm0 4h-4v3h4zm0 4h-4v3h3a1 1 0 0 0 1-1zm-5 3v-3H6v3zm-5 0v-3H1v2a1 1 0 0 0 1 1zm-4-4h4V8H1zm0-4h4V4H1zm5-3v3h4V4zm4 4H6v3h4z"/>
              </svg>
              Ouvrir le suivi CSM
            </router-link>
          </div>
        </div>

        <!-- Activity Monitoring Card -->
        <div class="dashboard-card activity-monitoring">
          <div class="card-header">
            <div class="card-icon activity-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15"/>
              </svg>
            </div>
            <div class="card-title-section">
              <h3 class="card-title">Monitoring d'activité</h3>
              <p class="card-description">Surveillance en temps réel de l'activité utilisateur</p>
            </div>
          </div>

          <div class="card-content">
            <router-link
              :to="{ name: 'activityPage' }"
              class="action-button secondary-button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M4 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4m2.625.547a3 3 0 0 0-5.584.953H.5a.5.5 0 0 0 0 1h.541A3 3 0 0 0 1 8a3 3 0 0 0 .041.5H.5a.5.5 0 0 0 0 1h.541a3 3 0 0 0 5.584.953V10.5a.5.5 0 0 0 1 0V8.5a.5.5 0 0 0-1 0v-.5a.5.5 0 0 0-.041-.5h.791a.5.5 0 0 0 0-1h-.791A.5.5 0 0 0 6.625 6.547z"/>
                <path d="M11 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4m2.625.547A3 3 0 0 0 11 6a3 3 0 0 0-2.625 2.547v-.5a.5.5 0 0 0-1 0v.5a.5.5 0 0 0 .041.5H6.625a.5.5 0 0 0 0 1h.791a.5.5 0 0 0 .041.5V10.5a.5.5 0 0 0 1 0v-.5a3 3 0 0 0 2.625-2.047V8.5a.5.5 0 0 0 1 0v-.953z"/>
              </svg>
              Voir l'activité
            </router-link>
          </div>
        </div>

        <div class="dashboard-card trial-monitoring">
          <div class="card-header">
            <div class="card-icon trial-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
              </svg>
            </div>
            <div class="card-title-section">
              <h3 class="card-title">Suivi des essais gratuits</h3>
              <p class="card-description">Monitoring des clients en fin d'essai</p>
            </div>
          </div>

          <div class="card-content">
            <router-link
              :to="{ name: 'trialMonitoring' }"
              class="action-button trial-button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
              </svg>
              Voir les essais
            </router-link>
          </div>
        </div>

        <div class="dashboard-card recent-signups">
          <div class="card-header">
            <div class="card-icon signups-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"/>
              </svg>
            </div>
            <div class="card-title-section">
              <h3 class="card-title">Suivi des inscriptions</h3>
              <p class="card-description">Voir les 50 derniers inscrits par téléphone</p>
            </div>
          </div>
          <div class="card-content">
            <router-link
              :to="{ name: 'recentSignups' }"
              class="action-button signups-button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
              </svg>
              Voir les inscriptions
            </router-link>
          </div>
        </div>

        <!-- Co-Sell Brief Card -->
        <div class="dashboard-card cosell-brief">
          <div class="card-header">
            <div class="card-icon" style="background: linear-gradient(135deg, #667eea, #764ba2); color: white;">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                <path d="M5 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
              </svg>
            </div>
            <div class="card-title-section">
              <h3 class="card-title">Mazodier IA</h3>
              <p class="card-description">Brief commercial du jour, par owner, avec actions à logger</p>
            </div>
          </div>
          <div class="card-content">
            <router-link
              :to="{ name: 'cosellBrief' }"
              class="action-button secondary-button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
              </svg>
              Ouvrir le brief
            </router-link>
          </div>
        </div>

        <!-- Feedback Monitoring Card -->
        <div class="dashboard-card feedback-monitoring">
          <div class="card-header">
            <div class="card-icon feedback-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.56 2a2.5 2.5 0 0 1 2.452 2.99L11.609 7h2.235a2.75 2.75 0 0 1 2.713 3.202l-.681 4.082A3.25 3.25 0 0 1 12.67 17H4.5A1.5 1.5 0 0 1 3 15.5V9.238a1.5 1.5 0 0 1 1.059-1.433l1.14-.35.139-.048a2.75 2.75 0 0 0 1.56-1.453L8.41 2.59l.07-.13A1 1 0 0 1 9.322 2zM7.81 6.365a3.75 3.75 0 0 1-2.126 1.98l-.192.065-1.14.35A.5.5 0 0 0 4 9.239V15.5a.5.5 0 0 0 .5.5h8.17a2.25 2.25 0 0 0 2.22-1.88l.68-4.082A1.75 1.75 0 0 0 13.844 8H11a.5.5 0 0 1-.49-.598l.521-2.608A1.5 1.5 0 0 0 9.561 3h-.238z"/>
              </svg>
            </div>
            <div class="card-title-section">
              <h3 class="card-title">Feedback utilisateurs</h3>
              <p class="card-description">Analyse des retours sur la qualite des reponses</p>
            </div>
          </div>

          <div class="card-content">
            <router-link
              :to="{ name: 'feedbackMonitoring' }"
              class="action-button feedback-button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
              </svg>
              Voir les feedbacks
            </router-link>
          </div>
        </div>

        <!-- Pipelines data Card -->
        <div class="dashboard-card pipelines-monitoring">
          <div class="card-header">
            <div class="card-icon pipelines-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5"/>
              </svg>
            </div>
            <div class="card-title-section">
              <h3 class="card-title">Pipelines data</h3>
              <p class="card-description">Monitoring des pipelines Modal d'ingestion</p>
            </div>
          </div>
          <div class="card-content">
            <router-link :to="{ name: 'pipelinesAdmin' }" class="action-button pipelines-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
              </svg>
              Voir les pipelines
            </router-link>
          </div>
        </div>

        <!-- DAU / MAU Metrics Card (en dernier) -->
        <div class="dashboard-card activity-monitoring">
          <div class="card-header">
            <div class="card-icon activity-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M0 0h1v15h15v1H0zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07"/>
              </svg>
            </div>
            <div class="card-title-section">
              <h3 class="card-title">DAU / MAU</h3>
              <p class="card-description">Utilisateurs actifs &amp; stickiness (recherches lancées)</p>
            </div>
          </div>
          <div class="card-content">
            <router-link :to="{ name: 'metricsPage' }" class="action-button secondary-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M0 0h1v15h15v1H0zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07"/>
              </svg>
              Voir le dashboard
            </router-link>
          </div>
        </div>

        <!-- Usage des features workspace -->
        <div class="dashboard-card activity-monitoring">
          <div class="card-header">
            <div class="card-icon activity-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0v1.829Zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707L14 2.707ZM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707L7.293 4Zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1h1.829Zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1h1.829ZM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707L13.293 10ZM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0v1.829Zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0L8.354 9.06Z"/>
              </svg>
            </div>
            <div class="card-title-section">
              <h3 class="card-title">Usage des features</h3>
              <p class="card-description">Baguette, réorganisation, périmètre, upload… (workspace)</p>
            </div>
          </div>
          <div class="card-content">
            <router-link :to="{ name: 'featureUsage' }" class="action-button secondary-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path d="M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0v1.829Zm1.854 3.388a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0L8.354 9.06Z"/>
              </svg>
              Voir le dashboard
            </router-link>
          </div>
        </div>

      </div>

      <!-- Quick Actions Bar -->
      <div class="quick-actions">
        <h3 class="quick-actions-title">Actions rapides</h3>
        <div class="quick-actions-grid">
          <router-link :to="{ name: 'activityPage' }" class="quick-action-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
            </svg>
            Activité récente
          </router-link>

          <router-link :to="{ name: 'inviteCreator' }" class="quick-action-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"/>
            </svg>
            Nouvelle invitation
          </router-link>

          <router-link :to="{ name: 'trialMonitoring' }" class="quick-action-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
            </svg>
            Essais gratuits
          </router-link>

          <router-link :to="{ name: 'feedbackMonitoring' }" class="quick-action-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.56 2a2.5 2.5 0 0 1 2.452 2.99L11.609 7h2.235a2.75 2.75 0 0 1 2.713 3.202l-.681 4.082A3.25 3.25 0 0 1 12.67 17H4.5A1.5 1.5 0 0 1 3 15.5V9.238a1.5 1.5 0 0 1 1.059-1.433l1.14-.35.139-.048a2.75 2.75 0 0 0 1.56-1.453L8.41 2.59l.07-.13A1 1 0 0 1 9.322 2zM7.81 6.365a3.75 3.75 0 0 1-2.126 1.98l-.192.065-1.14.35A.5.5 0 0 0 4 9.239V15.5a.5.5 0 0 0 .5.5h8.17a2.25 2.25 0 0 0 2.22-1.88l.68-4.082A1.75 1.75 0 0 0 13.844 8H11a.5.5 0 0 1-.49-.598l.521-2.608A1.5 1.5 0 0 0 9.561 3h-.238z"/>
            </svg>
            Feedbacks
          </router-link>

        </div>
      </div>

      <!-- Dev tools — discrete admin utilities -->
      <div class="dev-tools">
        <h4 class="dev-tools-title">Outils internes</h4>
        <div class="dev-tool-row">
          <label class="dev-tool-label">Breakdown des coûts d'un dossier</label>
          <div class="dev-tool-input-group">
            <input
              v-model="costDossierId"
              type="text"
              placeholder="UUID du dossier (mode AGENT)"
              class="dev-tool-input"
              @keyup.enter="goToCostBreakdown"
            />
            <button @click="goToCostBreakdown" class="dev-tool-btn" :disabled="!costDossierId.trim()">
              Analyser
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminDashboard',
  data() {
    return {
      costDossierId: '',
    };
  },
  methods: {
    goToCostBreakdown() {
      const id = (this.costDossierId || '').trim();
      if (!id) return;
      const uuidRe = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      if (!uuidRe.test(id)) {
        if (this.$toast && this.$toast.error) {
          this.$toast.error("UUID invalide");
        } else {
          alert("UUID invalide");
        }
        return;
      }
      this.$router.push({ name: 'dossierCostBreakdown', params: { dossierId: id } });
    },
  },
};
</script>

<style scoped>

.feedback-icon {
  background: linear-gradient(135deg, #43e97b, #38f9d7);
  color: white;
}

.feedback-button {
  background: linear-gradient(135deg, #43e97b, #38f9d7);
  color: white;
}

.feedback-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(67, 233, 123, 0.4);
}

.pipelines-icon {
  background: linear-gradient(135deg, #4facfe, #00f2fe);
  color: white;
}

.pipelines-button {
  background: linear-gradient(135deg, #4facfe, #00f2fe);
  color: white;
}

.pipelines-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);
}

.signups-icon {
  background: linear-gradient(135deg, #21D4FD, #B721FF);
  color: white;
}

.signups-button {
  background: linear-gradient(135deg, #21D4FD, #B721FF);
  color: white;
}

.signups-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(183, 33, 255, 0.4);
}

.admin-dashboard {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem 1rem;
}

.dashboard-container {
  max-width: 1200px;
  margin: 0 auto;
}

.dashboard-header {
  text-align: center;
  margin-bottom: 3rem;
  color: white;
}

.dashboard-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.dashboard-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
  margin: 0;
  font-weight: 300;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

.dashboard-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.card-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  flex-shrink: 0;
}

.admin-icon {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}

.csm-icon {
  background: linear-gradient(135deg, #1D9E75, #0F6E56);
  color: white;
}

.activity-icon {
  background: linear-gradient(135deg, #f093fb, #f5576c);
  color: white;
}

.card-title-section {
  flex: 1;
}

.trial-icon {
  background: linear-gradient(135deg, #e53e3e, #c53030);
  color: white;
}

.trial-button {
  background: linear-gradient(135deg, #e53e3e, #c53030);
  color: white;
}

.trial-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(229, 62, 62, 0.4);
}

.card-title {
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
}

.card-description {
  margin: 0;
  font-size: 0.9rem;
  color: #718096;
  line-height: 1.4;
}

.card-content {
  margin-top: 1rem;
}

.action-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 12px 20px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  font-size: 0.95rem;
}

.primary-button {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}

.primary-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.secondary-button {
  background: linear-gradient(135deg, #f093fb, #f5576c);
  color: white;
}

.secondary-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(240, 147, 251, 0.4);
}

.quick-actions {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.quick-actions-title {
  margin: 0 0 1.5rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
}

.quick-actions-grid {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.quick-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 16px;
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
  border: 1px solid rgba(102, 126, 234, 0.2);
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.quick-action-btn:hover {
  background: rgba(102, 126, 234, 0.15);
  border-color: rgba(102, 126, 234, 0.3);
  transform: translateY(-1px);
}

/* Dev tools — discrete, low-key */
.dev-tools {
  margin-top: 1.5rem;
  padding: 1rem 1.25rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px dashed rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  backdrop-filter: blur(6px);
  opacity: 0.75;
  transition: opacity 0.3s ease;
}

.dev-tools:hover,
.dev-tools:focus-within {
  opacity: 1;
}

.dev-tools-title {
  margin: 0 0 0.75rem 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.dev-tool-row {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.dev-tool-label {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
}

.dev-tool-input-group {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
}

.dev-tool-input {
  flex: 1;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  font-size: 0.85rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  color: #2d3748;
  min-width: 280px;
}

.dev-tool-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.25);
}

.dev-tool-btn {
  padding: 8px 14px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 6px;
  color: white;
  font-weight: 500;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.dev-tool-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.28);
  border-color: rgba(255, 255, 255, 0.5);
}

.dev-tool-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive design */
@media (max-width: 768px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .dashboard-title {
    font-size: 2rem;
  }

  .quick-actions-grid {
    flex-direction: column;
  }

  .dashboard-card {
    padding: 1.5rem;
  }

  .dev-tool-input-group {
    flex-direction: column;
  }

  .dev-tool-input {
    min-width: 0;
  }
}
</style>
